<template lang="pug">
  footer(id="footer" v-if="!loading")
    .desktop(:class="{ white: whiteFooter}")
      .grid-noBottom
        .col-3
          h2.subscribe(@click="subscribe=true")
            | join our newsletter
          .social
            a(href="https://www.facebook.com/caaminla" target="_blank")
              figure
                img(src="/static/icons/facebook.svg" alt="facebook icon")
            a(href="https://twitter.com/caaminla" target="_blank")
              figure
                img(src="/static/icons/twitter.svg" alt="twitter icon")
            a(href="https://www.instagram.com/caaminla/" target="_blank")
              figure
                img(src="/static/icons/instagram.svg" alt="instagram icon")
            a(href="https://www.youtube.com/channel/UCxbgXMDaQPRWeBxTd85HtFg" target="_blank")
              figure
                img(src="/static/icons/youtube.svg" alt="youtube icon")
          p.hours
            | <b> Hours </b> <br/>
            | Galleries Open <br/>
            | Tuesdays-Saturdays <br/>
            | 10:00 a.m.-5:00 p.m. <br/>
            | Sundays <br/>
            | 11:00 a.m.-5:00p.m.
        .col-9(:class="{ grey: subscribe}")
          .grid.nav.no-margin(v-if="!subscribe")
            .col-4(v-for="items in mapRoot()")
              ul
                li(v-for="item in items" )
                  router-link(:to="{ name: item.uid}")
                    h3
                      | {{ item.title }}
                  ul#subnav
                    li(v-for="child in item.children")
                      router-link(
                        v-if="(item.uid !== 'exhibitions' && item.uid !== 'programs' && item.uid !== 'learn' && item.uid !== 'about')"
                        :to="{name: `${item.uid}-page`, params: { id: formatRoute(child.uid) }}"
                      )
                        | {{ child.title.toLowerCase()}}
                      router-link(
                        v-if="item.uid === 'exhibitions'"
                        :to="{name: `${item.uid}`, query: { status: formatRoute(child.uid) }}"
                      )
                        | {{ child.title.toLowerCase()}}
                      router-link(
                        v-if="item.uid === 'programs'"
                        :to="{name: `${item.uid}-overview`, params: { category: formatRoute(child.uid) }}"
                      )
                        | {{ child.title.toLowerCase() }}
                      router-link(
                        v-if="item.uid === 'learn' && child.uid === '600state'"
                        :to="{name: 'blog'}"
                      )
                        | {{ child.title.toLowerCase() }}
                      router-link(
                        v-else-if="item.uid === 'learn' && child.uid !== '600state'"
                        :to="{name: `${item.uid}-page`, params: { id: formatRoute(child.uid) }}"
                      )
                        | {{ child.title.toLowerCase() }}
                      router-link(
                        v-else-if="(item.uid === 'about' && child.uid !== 'subscribe')"
                        :to="{name: `${item.uid}-page`, params: { id: formatRoute(child.uid) }}"
                      )
                        | {{ child.title.toLowerCase() }}
                      p(v-else-if="(item.uid === 'about' && child.uid === 'subscribe')" @click="subs")
                        | {{ child.title.toLowerCase() }}
          .newsletter(v-if="subscribe")
            form(v-if="!message")
              span(v-show="errors.has('email')" class="help is-danger")
                | {{ errors.first('email') }}
              input(type="text", v-model="email", v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('email') }", placeholder="email", name="email")
              input(type="text", v-model="first", placeholder="first name")
              input(type="text", v-model="last", placeholder="last name")
              span(v-show="errors.has('zip')" class="help is-danger")
                | {{ errors.first('zip') }}
              input(type="text", v-model="zip", v-validate="'numeric'" :class="{'input': true, 'is-danger': errors.has('zip') }", placeholder="zip code", name="zip")
              button(type="button", @click="submit")
                | subscribe!
            .message(v-if="message")
              h2
                | {{ message }}
            .x(@click="xOut")
              visual(image="/static/icons/x_out.svg" alt="exit newsletter signup")
      .grid
        .col-3
          .logo-container
            #logo-bottom(v-if="!whiteFooter")
              visual(image="/static/logos/caam_logo_white.svg" alt="Caam Logo")
            #logo-bottom(v-if="whiteFooter")
              visual(image="/static/logos/caam_logo.svg" alt="Caam Logo")
        .col-9
          #slogan-bottom
            h2.free(v-if="!subscribe" :class="{ white: whiteFooter}")
              | art. history. culture.
    .mobile(:class="{ white: whiteFooter}")
      h2.subscribe(@click="subscribe=true" :class="{ grey: whiteFooter}")
        | join our newsletter
      .newsletter.grey(v-if="subscribe")
        form(v-if="!message")
          span(v-show="errors.has('email')" class="help is-danger")
            | {{ errors.first('email') }}
          input(type="text", v-model="email", v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('email') }", placeholder="email", name="email")
          span(v-show="errors.has('zip')" class="help is-danger")
            | {{ errors.first('zip') }}
          input(type="text", v-model="zip", v-validate="'numeric'" :class="{'input': true, 'is-danger': errors.has('zip') }", placeholder="zip code", name="zip")
          button(type="button", @click="submit")
            | subscribe!
          .message(v-if="message")
            h2
              | {{ message }}
          .x(@click="xOut")
            visual(image="/static/icons/x_out.svg" alt="exit newsletter signup")
      p.hours
        | Hours <br/>
        | Galleries Open <br/>
        | Tuesdays-Saturdays 10:00 a.m.-5:00 p.m. <br/>
        | Sundays 11:00 a.m.-5:00 p.m.
      h2
        | California <br/>
        | African American <br/>
        | Museum
      p
        | 600 State Drive, Exposition Park, Los Angeles, CA 90037
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
export default {
  name: 'bottom-nav',
  mixins: [DataMixin],
  props: ['footerColor'],
  data () {
    return {
      menu: false,
      active: null,
      subscribe: false,
      email: null,
      first: null,
      last: null,
      zip: null,
      message: false,
      roots: [],
      whiteFooter: false
    }
  },

  created () {
    this.requestData('root', 'root')
    this.whiteFooter = this.footerColor === 'white'
    window.addEventListener('resize', this.logoResize)
  },

  mounted () {
    let int = setInterval(() => {
      const lb = document.getElementById('logo-bottom')
      if (lb != null) {
        this.logoResize()
        clearInterval(int)
      }
    }, 50)
  },

  destroyed: function () {
    window.removeEventListener('resize', this.logoResize)
  },

  methods: {
    submit: function () {
      // const loc = window.location
      // const rootUrl = loc.protocol + '//' + loc.host
      // const url = rootUrl + '/api/newsletter/'
      const url = 'https://caamuseum.org/api/newsletter'
      // const url = 'http://localhost:8888/caam/api/newsletter'
      const data = {
        email: this.email,
        first: this.first,
        last: this.last,
        zip: this.zip
      }

      this.post(url, data, response => {
        this.message = response.data.message
      })
    },

    logoResize: function () {
      const height = document.getElementById('logo-bottom').clientHeight
      document.getElementById('slogan-bottom').style.height = height + 'px'
    },

    subs: function () {
      console.log('')
    },

    xOut: function () {
      this.subscribe = false
      this.message = false
      this.email = null
      this.first = null
      this.last = null
      this.zip = null
    },

    mapRoot: function () {
      let arr = this.loadedData.root
      let length = 3
      let chunks = []
      let i = 0
      while (i < arr.length) {
        chunks.push(arr.slice(i, i += length))
      }
      return chunks
    },

    formatRoute: function (item) {
      return item.replace(/ |'/g, '-').toLowerCase()
    }
  }
}

</script>

<style lang="sass">
  @import '../styles/main'
  footer
    .grey
      background-color: rgba(255,255,255,0.95)
    .mobile
      display: none
      color: #FFF
      background-color: #000
      position: relative
      height: 26rem
      &.white
        background-color: #FFF
        color: #000
      @include respond-to(xs)
        display: block
      h2
        font-size: 3rem
        line-height: 2.6rem
      .subscribe
        font-size: 2.5rem
        padding-top: 1.7rem
        &.grey
          color: #636466
      .hours
        color: #636466
      p
        font-size: 1.2rem
        line-height: 1.2rem
        padding-top: 1.7rem
        padding-bottom: 1.7rem
      >*
        margin-left: 5%
        margin-right: 5%
    .desktop
      @include respond-to(xs)
        display: none
      background-color: #000
      margin-top: 8.8rem
      color: #636466
      height: auto
      @include respond-to(xs)
        height: unset
      &.white
        background-color: #FFF
      h3
        font-size: 4rem
        letter-spacing: $kerningTight
        font-weight: 700
        padding-left: 0
      .nav
        margin-top: 1rem
      .social
        display: flex
        justify-content: flex-start
        figure
          margin: 0
          margin-right: 10px
          margin-top: 1rem
          width: 20px
          img
            width: 100%
      .hours
        margin-top: 2.5em
    // #slogan-bottom
    //   position: relative
    //   .free
    //     font-size: 5rem
    //     position: absolute
    //     bottom: 0
    //     line-height: 90%
    //     color: #FFF
    //     padding-left: 0
    //     letter-spacing: $kerningTight
    //     &.white
    //       color: #000
    // .logo-container
    //   position: relative
    //   width: 100%
    //   height: 100%
    //   #logo-bottom
    //     position: absolute
    //     width: 100%
    //     left: 0
    #subnav > li > a
      font-size: 1.9rem
      letter-spacing: $kerningWide
      line-height: 160%
      font-weight: 400
    .subscribe
      cursor: pointer
      font-size: 5em
      line-height: 1
      margin-top: 1rem
      letter-spacing: $kerningTight
    >ul
      position: absolute
      z-index: -1
    .newsletter
      margin-top: 11vH
      height: 72vH
      @include respond-to(xs)
        width: 100%
        height: 24.3rem
        margin: 0
        padding-top: 1.7rem
        position: absolute
        top: 0
      input, button
        text-align: left
        z-index: 999
        font-size: 3rem
        font-weight: 700
        margin-left: 9vW
        border: none
        margin-bottom: 2em
        @include respond-to(xs)
          font-size: 2rem
          margin-left: 5%
          margin-bottom: 2.2rem
      input[type="text"]
        width: 78%
        outline: 0
        border-bottom: solid 2px #000
        border-radius: 0
        background-color: rgba(255,255,255,0)
        color: black
        @include respond-to(xs)
          width: 82.5%
          margin-left: 5%
      span
        width: 78%
        margin-left: 9vW
        font-size: 1.8rem
        color: red
        @include respond-to(xs)
          margin-left: 5%
          font-size: 1.2rem
      button
        display: block
        background: none
        padding: 0
        color: #000
        cursor: pointer
        border-bottom: solid 2px #000
        &:hover
          border-bottom: solid 2px #000
        @include respond-to(xs)
          margin-top: 4rem
      .vv-visual
        margin-left: 4rem
        width: 3rem
        cursor: pointer
        @include respond-to(xs)
          margin-left: 5%
          width: 2rem
    .message
      height: 44rem
      display: flex
      justify-content: center
      align-items: center
</style>



// WEBPACK FOOTER //
// BottomNav.vue?18cc38e4